import { P as PostIcon$1, d as defineCustomElement$1 } from './post-icon2.js';

const PostIcon = PostIcon$1;
const defineCustomElement = defineCustomElement$1;

export { PostIcon, defineCustomElement };
